import React, { useState, useEffect } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { useNavigate } from "react-router-dom";
import AuthInfoObj from "../../ApiServices/AuthInfoObj.js";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";

const ElectricityService = () => {
  const navigate = useNavigate();
  const isLoggedIn =
    sessionStorage.getItem("session") &&
    sessionStorage.getItem("sessionID") &&
    sessionStorage.getItem("userID");
  const [getNumData, setNumData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [operatorParams, setOperatorParams] = useState([]);
  const [accountInputLabel, setAccountInputLabel] = useState("");
  const [opOptionalDic, setOpOptionalDic] = useState([]);
  const [input, setInput] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [getDiscountAmtData, setDiscountAmtData] = useState({});
  const [getBalanceData, setBalanceData] = useState({});
  const [getPaymentTransaction, setPaymentTransaction] = useState();
  const [getTransactionStatus, setTransactionStatus] = useState({});
  const [getPaymentModeData, setGetPaymentModeData] = useState([]);
  const [addMoneyPopup, setAddMoneyPopup] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [isBillFetchedData, setIsBillFetchedData] = useState(null);
  const [paymentGatewayData, setPaymentGatewayData] = useState({});
  const [showFetchBillPopUp, setshowFetchBillPopUp] = useState(false);
  const [isRechargeAttempted, setIsRechargeAttempted] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedOperatorData, setSelectedOperatorData] = useState({});
  const location = useLocation();
  const [isFetchingBill, setIsFetchingBill] = useState(false);
  const [isRechargeProcess, setGetRechargeProcess] = useState(false);
  const [setBillFetchResponseMessage, getBillFetchResponseMessage] = useState();

  const PG_TYPES = {
    PAYTM: 1,
    RZRPAY: 2,
    ICICIUPI: 3,
    AGRPAY: 4,
    UPIGATEWAY: 5,
    PAYU: 6,
    PAYTMJS: 7,
    CASHFREE: 8,
    CASHFREEDEMOTEST: 9,
    UPIGATEWAYNEW: 10,
    MITRAGATEWAY: 11,
    ALLUPI: 12,
    PHONEPE: 18,
    USDTGATEWAY: 19,
  };

  const getNumberList = async (serviceID) => {
    try {
      const res = await ApiCalling.request(
        "POST",
        "/GetNumberList",
        null,
        null,
      );
      if (res?.statuscode === 1) {
        const allOperators = res.data?.operators || [];
        setNumData(allOperators);

        const filtered = allOperators.filter(
          (item) => item.opType === serviceID,
        );
        const formatted = filtered.map((item) => ({
          oid: item.oid,
          label: item.name,
          image: item.image,
        }));
        setFilteredList(formatted);
      } else {
        console.error(res?.msg);
      }
    } catch (err) {
      console.error("Error getNumberList:", err);
    }
  };

  const onOperatorSelect = (selectedOption) => {
    const selectedOid = selectedOption?.oid || "";
    setSelectedOperator(selectedOid);

    if (selectedOid) {
      getB2COpDetail(selectedOid);
    }
  };

  const getB2COpDetail = async (selectedOperator) => {
    try {
      const bodyObject = {
        oid: selectedOperator,
      };
      const res = await ApiCalling.request(
        "POST",
        "/B2COpDetail",
        bodyObject,
        null,
      );
      if (res?.statuscode === 1) {
        const detail = res?.operatorDetail || {};
        const label = detail.accountName || "Account Number";
        setAccountInputLabel({
          label,
          name: label,
          isBilling: detail.isBilling || false,
          exactNessID: detail.exactNessID || null,
        });

        const params = res?.operatorOptional?.operatorParams || [];
        setOperatorParams(params);

        const dic = res?.operatorOptional?.opOptionalDic || [];
        setOpOptionalDic(dic);
        setSelectedOperatorData(res?.operatorDetail || {});
      } else {
        console.error(res?.msg);
      }
    } catch (err) {
      console.error("Error getB2COpDetail:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchBillDetail = async () => {
    const newErrors = {};
    setIsRechargeAttempted(true); // You can use this to trigger field-level error visibility

    // 1. Validate Operator
    if (!selectedOperator) {
      newErrors.selectedOperator = "Please select an operator";
    }

    // 2. Validate main account input (like Consumer Number)
    if (accountInputLabel?.name) {
      const fieldValue = input[accountInputLabel.name]?.trim();

      if (!fieldValue) {
        newErrors[accountInputLabel.name] =
          `Please enter ${accountInputLabel.label}`;
      } else {
        const regex = selectedOperatorData?.regExAccount
          ? new RegExp(selectedOperatorData.regExAccount)
          : null;

        if (regex && !regex.test(fieldValue)) {
          newErrors[accountInputLabel.name] = "Invalid format";
        }

        const minLength = selectedOperatorData?.length;
        const maxLength = selectedOperatorData?.lengthMax;

        if (
          (minLength && fieldValue.length < minLength) ||
          (maxLength && fieldValue.length > maxLength)
        ) {
          newErrors[accountInputLabel.name] =
            `${accountInputLabel.label} must be between ${minLength} and ${maxLength} digits`;
        }
      }
    }

    // ✅ 3. Validate dynamic operatorParams (new structure)
    operatorParams.forEach((param) => {
      const key = param.paramName;
      const value = input[key]?.trim();

      if (param.isOptional) return;

      if (!value) {
        newErrors[key] = `Please enter ${key}`;
        return;
      }

      // Regex validation
      if (param.regEx) {
        const regex = new RegExp(param.regEx);
        if (!regex.test(value)) {
          newErrors[key] = `Invalid ${key} format`;
        }
      }

      // Length validation
      const minLength = param.minLength;
      const maxLength = param.maxLength;

      if (
        (minLength && value.length < minLength) ||
        (maxLength && value.length > maxLength)
      ) {
        newErrors[key] =
          `${key} must be between ${minLength} and ${maxLength} characters`;
      }

      // Alphanumeric validation
      // if (param.dataType === "ALPHANUMERIC" && /[^a-zA-Z0-9 ]/.test(value)) {
      //   newErrors[key] = `${key} must be alphanumeric`;
      // }
    });

    // 4. Validate Customer Mobile Number
    if (!input?.CustomerNo?.trim()) {
      newErrors.CustomerNo = "Please enter Customer Mobile No.";
    } else if (!/^[6-9][0-9]{9}$/.test(input.CustomerNo)) {
      newErrors.CustomerNo = "Invalid Mobile No.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;
    setIsFetchingBill(true);

    try {
      if (!isLoggedIn) {
        sessionStorage.setItem(
          "pendingRecharge",
          JSON.stringify({
            selectedOperator,
            input,
            accountInputName: accountInputLabel?.name,
            isBilling: accountInputLabel?.isBilling || false,
            exactNessID: accountInputLabel?.exactNessID || null,
            operatorParams, // optional but helpful to reconstruct o1/o2/o3
          }),
        );
        return navigate("/loginOtp");
      }
      const paramValues = {};
      operatorParams.forEach((param, index) => {
        paramValues[`o${index + 1}`] = input[param.paramName] || "";
      });
      const bodyObject = {
        oid: selectedOperator,
        accountNo: input[accountInputLabel.name] || "",
        ...paramValues,
        CustomerNo: input?.CustomerNo,
      };
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/FetchBill",
        data: bodyObject,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.bBPSResponse?.statuscode === 1) {
        setIsBillFetchedData(res?.bBPSResponse);
        setInput((prev) => ({
          ...prev,
          Amount: res?.bBPSResponse?.amount?.toString() || "",
        }));
        setshowFetchBillPopUp(true);
      } else {
        console.error(res?.msg);
        // toast.error(res?.bBPSResponse?.errorMsg);
        getBillFetchResponseMessage(res?.bBPSResponse?.errorMsg);
      }
    } catch (err) {
      console.error("Error fetchBillDetail:", err);
    } finally {
      setIsFetchingBill(false);
    }
  };

  const handleRechargeClick = async () => {
    const newErrors = {};
    setIsRechargeAttempted(true); // You can use this to trigger field-level error visibility

    // 1. Validate Operator
    if (!selectedOperator) {
      newErrors.selectedOperator = "Please select an operator";
    }

    // 2. Validate main account input (like Consumer Number)
    if (accountInputLabel?.name) {
      const fieldValue = input[accountInputLabel.name]?.trim();

      if (!fieldValue) {
        newErrors[accountInputLabel.name] =
          `Please enter ${accountInputLabel.label}`;
      } else {
        const regex = selectedOperatorData?.regExAccount
          ? new RegExp(selectedOperatorData.regExAccount)
          : null;

        if (regex && !regex.test(fieldValue)) {
          newErrors[accountInputLabel.name] = "Invalid format";
        }

        const minLength = selectedOperatorData?.length;
        const maxLength = selectedOperatorData?.lengthMax;

        if (
          (minLength && fieldValue.length < minLength) ||
          (maxLength && fieldValue.length > maxLength)
        ) {
          newErrors[accountInputLabel.name] =
            `${accountInputLabel.label} must be between ${minLength} and ${maxLength} digits`;
        }
      }
    }

    // ✅ 3. Validate dynamic operatorParams (new structure)
    operatorParams.forEach((param) => {
      const key = param.paramName;
      const value = input[key]?.trim();

      if (param.isOptional) return;

      if (!value) {
        newErrors[key] = `Please enter ${key}`;
        return;
      }

      // Regex validation
      if (param.regEx) {
        const regex = new RegExp(param.regEx);
        if (!regex.test(value)) {
          newErrors[key] = `Invalid ${key} format`;
        }
      }

      // Length validation
      const minLength = param.minLength;
      const maxLength = param.maxLength;

      if (
        (minLength && value.length < minLength) ||
        (maxLength && value.length > maxLength)
      ) {
        newErrors[key] =
          `${key} must be between ${minLength} and ${maxLength} characters`;
      }

      // Alphanumeric validation
      // if (param.dataType === "ALPHANUMERIC" && /[^a-zA-Z0-9 ]/.test(value)) {
      //   newErrors[key] = `${key} must be alphanumeric`;
      // }
    });

    // 4. Validate Customer Mobile Number
    if (!input?.CustomerNo?.trim()) {
      newErrors.CustomerNo = "Please enter Customer Mobile No.";
    } else if (!/^[6-9][0-9]{9}$/.test(input.CustomerNo)) {
      newErrors.CustomerNo = "Invalid Mobile No.";
    }

    // 5. Validate Amount
    const amount = parseFloat(input?.Amount);
    const fetchedAmount = parseFloat(isBillFetchedData?.amount);
    const exactNessID = accountInputLabel?.exactNessID;
    if (!amount || isNaN(amount) || amount <= 0) {
      newErrors.Amount = "Invalid Amount";
    } else {
      switch (exactNessID) {
        case 1: // Exact
          if (amount !== fetchedAmount) {
            newErrors.Amount = `Amount must be exactly ₹${fetchedAmount}`;
          }
          break;
        case 2: // ExactAndAbove
          if (amount < fetchedAmount) {
            newErrors.Amount = `Amount must be ₹${fetchedAmount} or more`;
          }
          break;
        case 3: // ExactAndBelow
          if (amount > fetchedAmount) {
            newErrors.Amount = `Amount must be ₹${fetchedAmount} or less`;
          }
          break;
        case 4: // All
          // No extra validation
          break;
        default:
          newErrors.Amount = "Invalid billing type";
      }
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    setGetRechargeProcess(true);

    try {
      if (!isLoggedIn) {
        sessionStorage.setItem(
          "pendingRecharge",
          JSON.stringify({
            selectedOperator,
            input,
            accountInputName: accountInputLabel?.name,
            isBilling: accountInputLabel?.isBilling || false,
            exactNessID: accountInputLabel?.exactNessID || null,
            operatorParams, // optional but helpful to reconstruct o1/o2/o3
          }),
        );
        return navigate("/loginOtp");
      }
      sessionStorage.setItem(
        "pgRedirectedFrom",
        JSON.stringify({
          path: location.pathname,
          selectedOperator,
          input,
          accountInputName: accountInputLabel?.name,
          isBilling: accountInputLabel?.isBilling || false,
          exactNessID: accountInputLabel?.exactNessID || null,
          operatorParams, // optional but helpful to reconstruct o1/o2/o3
        }),
      );
      await rechargeDiscountOffer(input?.Amount);
      await getBalanceUser();
      setShowPopup(true);
    } catch (error) {
      console.error("Recharge process failed", error);
    } finally {
      setGetRechargeProcess(false);
    }
  };

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const rechargeDiscountOffer = async (amount) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetCommissionAmount",
        data: {
          ID: 0,
          amount: amount,
          appid: APPID,
          imei: "",
          loginTypeID: 1,
          oid: selectedOperator,
          paymentID: 0,
          regKey: "",
          serialNo: "",
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          version: VERSION,
          Account: input?.CustomerNo,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res?.statuscode === 1) {
        setDiscountAmtData(res?.cashBackResp);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };
  const paymentTransaction = async (
    amount,
    oid,
    accountNo,
    customerNo,
    fetchBilID,
  ) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const geoCode = `${latitude},${longitude}`;

        const optionalParams = {};
        operatorParams.forEach((param, index) => {
          optionalParams[`o${index + 1}`] = input[param.paramName] || "";
        });

        const finalAmount =
          input?.Amount !== undefined && input?.Amount !== ""
            ? input.Amount
            : isBillFetchedData?.amount;
        const data = {
          loginTypeID: 1,
          oid: oid,
          accountNo: accountNo,
          amount: finalAmount,
          geoCode: geoCode,
          customerNo: customerNo,
          imei: "",
          regKey: "",
          serialNo: "",
          ...optionalParams,
          fetchBilID: fetchBilID,
          isReal: false,
          refID: "",
          securityKey: "",
        };

        try {
          const res = await ApiCalling.apiClient.request({
            method: "POST",
            url: "/Transaction",
            data,

            headers: {
              "Content-Type": "application/json",
              appid: APPID,
              version: VERSION,
              session: AuthInfoObj().session,
              sessionID: AuthInfoObj().sessionID,
              userID: AuthInfoObj().userID,
            },
          });

          if (res?.statuscode === 1) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 2) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else if (res?.statuscode === 3) {
            setTransactionStatus({ statuscode: res?.statuscode });
          } else {
            console.error(res?.msg);
          }
          setPaymentTransaction(res);
          setShowPopup(false);
          setSuccessPopup(true);
        } catch (error) {
          console.error("Error in paymentTransaction:", error);
        }
      },
      (error) => {
        console.error("Failed to fetch geolocation:", error);
      },
    );
  };

  const getPaymentMode = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPaymentMode",
        data: {},
        headers: {
          "Content-Type": "application/json",
          appid: APPID,
          version: VERSION,
          session: AuthInfoObj().session,
          sessionID: AuthInfoObj().sessionID,
          userID: AuthInfoObj().userID,
          loginTypeID: 1,
        },
      });

      if (res?.statuscode === 1) {
        setGetPaymentModeData(res.data.operators || []);
        setShowPopup(false);
        setAddMoneyPopup(true);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in rechargeDiscountOffer:", error);
    }
  };

  const handleClickGateway = (id, remainamt) => {
    getPGDetail(id, remainamt);
  };

  const getPGDetail = async (id, remainamt) => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetPGDetail",
        data: {
          id: id,
          a: remainamt.toString(),
          w: 1,
          vpa: "",
        },
        headers: {
          "Content-Type": "application/json",
          AppID: APPID,
          Version: VERSION,
          Session: AuthInfoObj().session,
          SessionID: AuthInfoObj().sessionID,
          UserID: AuthInfoObj().userID,
          Referer: REFERER,
        },
      });

      if (res?.statuscode === 1) {
        const data = res?.pGModelForWeb;

        switch (data?.pgType) {
          case PG_TYPES.PAYTMJS:
            setPaymentGatewayData({
              type: "paytm",
              paytmJSRequest: data?.paytmJSRequest,
            });
            break;

          case PG_TYPES.RZRPAY:
            setPaymentGatewayData({
              type: "razorpay",
              razorData: data,
            });
            break;

          case PG_TYPES.CASHFREE:
          case PG_TYPES.CASHFREEDEMOTEST:
            setPaymentGatewayData({
              type: "cashfree",
              cashfreeData: data,
            });
            break;

          case PG_TYPES.PHONEPE:
            setPaymentGatewayData({
              type: "phonepe",
              phonepeData: data,
            });
            break;

          default:
            alert("Unsupported or unhandled payment gateway: " + data?.pgType);
            break;
        }
        setAddMoneyPopup(false);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error in getPGDetail:", error);
    }
  };
  const handlePrint = () => {
    window.print();
  };

  const closeRechargePopup = () => {
    setShowPopup(false);

    setSelectedOperator("");
    setOperatorParams([]);
    setAccountInputLabel("");
    setOpOptionalDic([]);
    setInput([]);
    setErrors({});
    setIsRechargeAttempted(false);
    setIsBillFetchedData(null);
    setBalanceData({});
    setDiscountAmtData({});
    setPaymentTransaction();
    setTransactionStatus({});
    setGetPaymentModeData([]);
    setPaymentGatewayData({});
    setshowFetchBillPopUp(false);
  };
  const closeSuccessPopup = () => {
    setSuccessPopup(false);
    setSelectedOperator("");
    setOperatorParams([]);
    setAccountInputLabel("");
    setOpOptionalDic([]);
    setInput([]);
    setErrors({});
    setIsRechargeAttempted(false);
    setIsBillFetchedData(null);
    setBalanceData({});
    setDiscountAmtData({});
    setPaymentTransaction();
    setTransactionStatus({});
    setGetPaymentModeData([]);
    setPaymentGatewayData({});
    setshowFetchBillPopUp(false);
  };

  const closeAddMoneyPopup = () => {
    setAddMoneyPopup(false);

    setSelectedOperator("");
    setOperatorParams([]);
    setAccountInputLabel("");
    setOpOptionalDic([]);

    setInput([]);

    setErrors({});
    setIsRechargeAttempted(false);

    setIsBillFetchedData(null);

    setBalanceData({});
    setDiscountAmtData({});

    setPaymentTransaction();
    setTransactionStatus({});

    setGetPaymentModeData([]);
    setPaymentGatewayData({});

    setshowFetchBillPopUp(false);
  };
  const resetForm = () => {
    setSelectedOperator("");
    setOperatorParams([]);
    setAccountInputLabel("");
    setOpOptionalDic([]);

    setInput({});
    setErrors({});
    setIsRechargeAttempted(false);

    setIsBillFetchedData(null);
    setBalanceData({});
    setDiscountAmtData({});

    setPaymentTransaction();
    setTransactionStatus({});
    setGetPaymentModeData([]);
    setPaymentGatewayData({});

    setshowFetchBillPopUp(false);
    setShowPopup(false);
  };

  return {
    getNumberList,
    onOperatorSelect,
    filteredList,
    selectedOperator,
    operatorParams,
    accountInputLabel,
    opOptionalDic,
    input,
    handleChange,
    setInput,
    fetchBillDetail,
    setAccountInputLabel,
    setSelectedOperator,
    setOperatorParams,
    handleRechargeClick,
    getBalanceData,
    getDiscountAmtData,
    showPopup,
    setShowPopup,
    paymentTransaction,
    getPaymentMode,
    getPaymentTransaction,
    successPopup,
    addMoneyPopup,
    getPaymentModeData,
    getTransactionStatus,
    setSuccessPopup,
    isBillFetchedData,
    setAddMoneyPopup,
    handleClickGateway,
    paymentGatewayData,
    showFetchBillPopUp,
    errors,
    isRechargeAttempted,
    isFetchingBill,
    isRechargeProcess,
    setBillFetchResponseMessage,
    handlePrint,
    closeRechargePopup,
    closeSuccessPopup,
    closeAddMoneyPopup,
    resetForm,
  };
};

export default ElectricityService;
